module.exports = __webpack_public_path__ + "img/wait-search-loupe.0e8b9f99.svg";